/* ============================================================
   looxsmax — Custom product page JS
   Lightweight, theme-editor safe, no dependencies.
   ------------------------------------------------------------
   Handles:
     - Gallery thumb switching
     - FAQ accordion
     - Bundle picker
     - Variant swatch picker (and Shopify variant URL sync)
     - Quantity stepper
     - Sticky add-to-cart visibility
     - Recent-purchase ticker
     - Klarna installment refresh on variant change
   ============================================================ */
(function () {
  'use strict';

  // --- helpers ---------------------------------------------------------------
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function $(sel, root) { return (root || document).querySelector(sel); }
  function on(el, ev, fn) { if (el) el.addEventListener(ev, fn); }

  function money(cents) {
    if (typeof cents !== 'number') return '';
    var format = (window.Shopify && window.Shopify.money_format) || '${{amount}}';
    var value = (cents / 100).toFixed(2);
    return format
      .replace('{{amount}}', value)
      .replace('{{amount_no_decimals}}', Math.round(cents / 100).toString())
      .replace('{{amount_with_comma_separator}}', value.replace('.', ','))
      .replace('{{amount_no_decimals_with_comma_separator}}', Math.round(cents / 100).toString());
  }

  // --- Gallery ---------------------------------------------------------------
  function initGallery(root) {
    var thumbs = $$('.lxs-gallery .lxs-thumb', root);
    var slides = $$('.lxs-gallery .lxs-slide', root);
    if (!thumbs.length || !slides.length) return;
    thumbs.forEach(function (t, i) {
      on(t, 'click', function () {
        thumbs.forEach(function (x) { x.classList.remove('is-active'); });
        slides.forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
        if (slides[i]) slides[i].classList.add('is-active');
      });
    });
  }

  // --- FAQ -------------------------------------------------------------------
  function initFAQ(root) {
    $$('.lxs-faq-item', root).forEach(function (item) {
      var q = $('.lxs-faq-q', item);
      on(q, 'click', function () {
        var open = item.classList.contains('is-open');
        // Close siblings inside same FAQ wrap
        var wrap = item.parentElement;
        if (wrap) $$('.lxs-faq-item', wrap).forEach(function (s) { s.classList.remove('is-open'); });
        if (!open) item.classList.add('is-open');
      });
    });
  }

  // --- Bundle picker ---------------------------------------------------------
  function initBundles(root) {
    var bundles = $$('.lxs-bundle', root);
    if (!bundles.length) return;
    bundles.forEach(function (b) {
      on(b, 'click', function () {
        bundles.forEach(function (x) { x.classList.remove('is-active'); });
        b.classList.add('is-active');
        // Sync hidden quantity input if data-qty present
        var qty = b.getAttribute('data-bundle-qty');
        if (qty) {
          var qtyInput = $('input[name="quantity"]', root);
          if (qtyInput) {
            qtyInput.value = qty;
            qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
        // Sync total in CTA
        var total = b.getAttribute('data-bundle-total');
        var ctaTotal = $('[data-cta-total]', root);
        if (ctaTotal && total) ctaTotal.textContent = total;
      });
    });
  }

  // --- Quantity stepper ------------------------------------------------------
  function initQty(root) {
    $$('.lxs-qty', root).forEach(function (qty) {
      var input = $('input', qty);
      var dec = $('[data-qty-dec]', qty);
      var inc = $('[data-qty-inc]', qty);
      if (!input) return;
      function clamp(v) {
        v = parseInt(v, 10) || 1;
        var min = parseInt(input.getAttribute('min') || '1', 10);
        var max = parseInt(input.getAttribute('max') || '99', 10);
        return Math.min(max, Math.max(min, v));
      }
      on(dec, 'click', function () {
        input.value = clamp((parseInt(input.value, 10) || 1) - 1);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      on(inc, 'click', function () {
        input.value = clamp((parseInt(input.value, 10) || 1) + 1);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      on(input, 'change', function () { input.value = clamp(input.value); });
    });
  }

  // --- Variant picker --------------------------------------------------------
  // Reads variant data from a JSON script tag emitted by the Liquid section.
  // Updates: selected label, price, compare-at, save badge, hidden id input,
  // sold-out state, URL ?variant=, sticky cart, Klarna installment.
  function initVariants(root) {
    var dataEl = $('[data-variant-json]', root);
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!variants || !variants.length) return;

    var swatches = $$('.lxs-swatch', root);
    var hiddenId = $('input[name="id"]', root);
    var nowEls = $$('[data-price-now]', root);
    var wasEls = $$('[data-price-compare]', root);
    var saveEls = $$('[data-price-save]', root);
    var labelEl = $('[data-variant-label]', root);
    var atcBtn = $('[data-add-to-cart]', root);
    var atcLabel = $('[data-add-to-cart-label]', root);
    var stickyPriceNow = $('.lxs-sticky-cart [data-price-now]');
    var stickyPriceWas = $('.lxs-sticky-cart [data-price-compare]');
    var klarnaEl = $('[data-klarna]', root);

    function applyVariant(v) {
      if (!v) return;
      if (hiddenId) hiddenId.value = v.id;
      nowEls.forEach(function (el) { el.textContent = money(v.price); });
      if (stickyPriceNow) stickyPriceNow.textContent = money(v.price);
      if (v.compare_at_price && v.compare_at_price > v.price) {
        wasEls.forEach(function (el) { el.textContent = money(v.compare_at_price); el.style.display = ''; });
        if (stickyPriceWas) { stickyPriceWas.textContent = money(v.compare_at_price); stickyPriceWas.style.display = ''; }
        saveEls.forEach(function (el) {
          el.textContent = 'Save ' + money(v.compare_at_price - v.price);
          el.style.display = '';
        });
      } else {
        wasEls.forEach(function (el) { el.style.display = 'none'; });
        if (stickyPriceWas) stickyPriceWas.style.display = 'none';
        saveEls.forEach(function (el) { el.style.display = 'none'; });
      }
      if (labelEl) labelEl.textContent = v.title;
      if (klarnaEl) klarnaEl.textContent = money(Math.round(v.price / 4));
      if (atcBtn) {
        atcBtn.disabled = !v.available;
        if (atcLabel) atcLabel.textContent = v.available
          ? (atcBtn.getAttribute('data-label-add') || 'Add to Cart')
          : (atcBtn.getAttribute('data-label-soldout') || 'Sold Out');
      }
      // Update URL
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url);
      } catch (e) { /* noop */ }
    }

    swatches.forEach(function (s) {
      on(s, 'click', function () {
        var vid = parseInt(s.getAttribute('data-variant-id'), 10);
        swatches.forEach(function (x) { x.classList.remove('is-active'); });
        s.classList.add('is-active');
        var v = variants.filter(function (x) { return x.id === vid; })[0];
        applyVariant(v);
      });
    });

    // On load, apply the variant matching the hidden id (or first active swatch)
    if (hiddenId && hiddenId.value) {
      var current = variants.filter(function (x) { return String(x.id) === String(hiddenId.value); })[0];
      if (current) applyVariant(current);
    }
  }

  // --- Sticky cart -----------------------------------------------------------
  function initStickyCart() {
    var bar = $('.lxs-sticky-cart');
    if (!bar) return;
    document.body.classList.add('lxs-has-sticky');
    var threshold = parseInt(bar.getAttribute('data-show-after') || '700', 10);
    var onScroll = function () {
      if (window.scrollY > threshold) bar.classList.add('is-show');
      else bar.classList.remove('is-show');
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // --- Recent purchase ticker ------------------------------------------------
  function initTicker() {
    $$('.lxs-recent-ticker[data-events]').forEach(function (el) {
      var events;
      try { events = JSON.parse(el.getAttribute('data-events')); } catch (e) { return; }
      if (!events || !events.length) return;
      var slot = $('.lxs-ticker-slot', el);
      if (!slot) return;
      var i = 0;
      function render() {
        var e = events[i % events.length];
        slot.innerHTML = '<strong>' + e.name + '</strong> from ' + e.city +
          ' just ordered &middot; <span style="color:var(--lxs-clay)">' + e.ago + '</span>';
      }
      render();
      setInterval(function () { i++; render(); }, 3400);
    });
  }

  // --- Add to cart submission feedback --------------------------------------
  function initAddToCart() {
    var forms = $$('form.lxs-product-form');
    forms.forEach(function (form) {
      on(form, 'submit', function (e) {
        // Let theme.js or Shopify cart drawer handle the actual fetch if present.
        // Otherwise fall back to native form post.
        if (window.Shopify && window.Shopify.theme && typeof window.Shopify.theme.openCartDrawer === 'function') {
          // Intercept and post via fetch
          e.preventDefault();
          var fd = new FormData(form);
          fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function () { window.Shopify.theme.openCartDrawer(); })
            .catch(function () { form.submit(); });
        }
      });
    });
  }

  // --- Theme editor: re-init on section render ------------------------------
  function initAll(root) {
    initGallery(root);
    initFAQ(root);
    initBundles(root);
    initQty(root);
    initVariants(root);
    initTicker();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
      initStickyCart();
      initAddToCart();
    });
  } else {
    initAll(document);
    initStickyCart();
    initAddToCart();
  }

  // Re-init when Shopify Theme Editor re-renders a section
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function () { /* noop */ });
  document.addEventListener('shopify:block:select', function (e) { initAll(e.target); });
})();
